{
  "g-link": {
    "attributes": [
      "to",
      "replace",
      "append",
      "tag",
      "active-class",
      "exact",
      "event",
      "exact-active-class"
    ],
    "defaults": [":to"],
    "description": "Component for routing. Same as <router-link> now."
  },
  "g-image": {
    "attributes": [
      "src",
      "width",
      "height",
      "alt",
      "fit",
      "background",
      "immediate",
      "blur",
      "quality",
      "cover",
      "contain",
      "fill",
      "inside",
      "outside"
    ],
    "defaults": [":src"],
    "description": "Component that outputs an optimized progressive image. Will default to a standard img tag if javascript is not enabled."
  },
  "Pager": {
    "attributes": [
      "info",
      "showLinks",
      "showNavigation",
      "linkClass",
      "firstLabel",
      "prevLabel",
      "nextLabel",
      "lastLabel",
      "ariaLabel",
      "ariaLinkLabel",
      "ariaFirstLabel",
      "ariaCurrentLabel",
      "ariaPrevLabel",
      "ariaNextLabel",
      "ariaLastLabel"
    ],
    "defaults": [":info"],
    "description": "Component which allows for easy pagination. The passed info object must include the fields \"totalPages\" & \"currentPage\"."
  }
}
